import { SkeletonComponent } from '@shared/ui/skeleton/skeleton.component';
import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AuthRepository } from '@core/auth/state/auth.repository';
import { ThemeService } from '@core/services/theme.service';
import { BottomSheetMobileComponent } from '@shared/components/bottom-sheet-mobile/bottom-sheet-mobile.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { filter, map, Observable, switchMap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SeoService } from '@core/services/helpers/seo.service';
import { CityDialogService } from '@core/services/city-dialog.service';
import { StackedSnackbarContainerComponent } from '@shared/components/stacked-snackbar-container/stacked-snackbar-container.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [
    RouterOutlet,
    CommonModule,
    NgxSpinnerModule,
    BottomSheetMobileComponent,
    StackedSnackbarContainerComponent,
    // SkeletonComponent
  ],
})
export class AppComponent implements OnInit {
  private _seoService = inject(SeoService);
  private _router = inject(Router);
  private _cityDialogService = inject(CityDialogService);
  protected destroyRef: DestroyRef = inject(DestroyRef);

  themeService = inject(ThemeService);
  isDarkTheme$ = this.themeService.isDarkTheme$;

  private _authRepo = inject(AuthRepository);
  loading$ = this._authRepo.loading$;
  
  // Stream that emits true when user is authenticated
  isAuthenticated$ = this._authRepo.token$.pipe(
    map(token => !!token)
  );

  isPrivateModule: boolean = false;

  constructor() {
    // Track navigation events for private module checking
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event: NavigationEnd) => {
        window.scrollTo(0, 0); // Прокрутка страницы вверх
        this.isPrivateModule = event.url.includes('/private');
      });
      
    // Set up city preference when user is authenticated (without showing dialog)
    this.isAuthenticated$
      .pipe(
        // Only process when user is authenticated
        filter(isAuthenticated => isAuthenticated),
        // Set up default city preference
        switchMap(() => this._cityDialogService.checkAndShowCityDialog()),
        // Unsubscribe when component is destroyed
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(city => {
        if (city) {
          console.log('Default city set:', city);
        }
      });
  }

  ngOnInit() {
    // Initialize SEO service
    this._seoService.initializeSeoService();
  }
}
